import { formatUnits, toFormatterUnit } from "@suse-o11y/formatter-unit";

export interface FormatValueOptions {
	precision?: number;
	unit?: string;
}

export function formatValue(value: undefined | number, { precision, unit }: FormatValueOptions = {}): string {
	return value == null ? "-" : formatUnits(toFormatterUnit(unit), value, { precision });
}
